import { ComponentIds, TransformUtils } from '@inter-ikea-core/core';
import { PlannerValidation } from './PlannerValidation';
/**
 * Validates that hanging frames are not placed too close to ceiling or floor
 */
export class HangingFramePlacementValidation extends PlannerValidation {
    constructor(coreApi) {
        super(coreApi, 'HangingFramePlacementValidation');
    }
    validateCurrentState() {
        return this.validationOK();
    }
    validateSnap(snapActionCandidate) {
        const entity = snapActionCandidate.guestRoot;
        if (this.isEnabled &&
            entity.hasComponent(ComponentIds.FRAME_COMPONENT_ID) &&
            snapActionCandidate.hostConnector.isOffering('wall')) {
            const roomDimensions = this.coreApi.kvadratRoom?.getDimensions();
            const framePlacement = TransformUtils.worldPosition(entity);
            const frameDimensions = this.coreApi.entities.getEntityComSize(entity);
            if (!roomDimensions || !frameDimensions) {
                return this.validationOK();
            }
            return framePlacement.Y + frameDimensions?.height / 2 > roomDimensions.y - 50
                ? this.validationFail('Can not place haning frames closer than 5cm from ceiling')
                : framePlacement.Y - frameDimensions?.height / 2 < 50
                    ? this.validationFail('Can not place haning frames closer than 5cm from floor')
                    : this.validationOK();
        }
        return this.validationOK();
    }
}
//# sourceMappingURL=HangingFramePlacementValidation.js.map